import { DateTime } from 'luxon';

// Returns today, tomorrow, or beyond that the future date in format "Thursday 1 May"
// If "from" is supplied eg: "2pm", incorporates that into the message eg:
// "from 2pm tomorrow"
export const computeAvailableMessage = (isoDate, from) => {
    function isValidDate(dateString) {
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date.getTime());
    }
      
    const formatFriendlyDate = isoDate => {
        const day = DateTime.fromISO(isoDate).toFormat('EEEE');
        const date = DateTime.fromISO(isoDate).toFormat('d LLLL');
        
        return isValidDate(isoDate) ? `<span class="dayPart">${day}</span> <span class="datePart">${date}</span>` : 'Invalid DateTime';
    };

    if (!isoDate) {
        return null
    }

    const dt = DateTime.fromISO(isoDate).startOf("day");
    const now = DateTime.now();
    const diffInDays = dt.diff(now.startOf("day"), "days").days;

    switch(diffInDays) {
        case 0:
            return from ? `from ${from} today` : 'today';
        case 1:
            return from ? `from ${from} tomorrow` : 'tomorrow';
        default:
            return from ? `from ${from} on ${formatFriendlyDate(dt)}` : `${formatFriendlyDate(dt)}`;
    }
}
